var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area cl",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _c("div", { staticClass: "container-fluid xyz location-listing" }, [
        _c(
          "div",
          {
            staticClass: "page-header-top-container",
            staticStyle: { position: "fixed" }
          },
          [
            _c(
              "div",
              { staticClass: "page-name mb-1", staticStyle: { width: "100%" } },
              [_vm._v("My Orders")]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "page-name", staticStyle: { width: "100%" } },
              [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-md-6" },
                    [
                      _c("VueCtkDateTimePicker", {
                        attrs: {
                          range: "",
                          "only-date": _vm.date_picker_options.onlyDate,
                          "only-time": false,
                          "output-format": _vm.date_picker_options.outputFormat,
                          format: _vm.date_picker_options.inputFormat,
                          formatted: _vm.date_picker_options.formatted,
                          noClearButton: _vm.date_picker_options.noClearButton,
                          "custom-shortcuts":
                            _vm.date_picker_options.customShortcuts,
                          maxDate: _vm.date_picker_options.maxDate
                        },
                        on: {
                          input: function($event) {
                            return _vm.changeDatePickerDate()
                          }
                        },
                        model: {
                          value: _vm.date_picker_dates,
                          callback: function($$v) {
                            _vm.date_picker_dates = $$v
                          },
                          expression: "date_picker_dates"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-6" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary waves-effect pull-right",
                        attrs: { type: "submit" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.loadInventoryParts(true)
                          }
                        }
                      },
                      [_vm._v("Export")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary waves-effect pull-right",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.loadInventoryParts(false)
                          }
                        }
                      },
                      [_vm._v("Apply Filter")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary waves-effect pull-right",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.clearFilter()
                          }
                        }
                      },
                      [_vm._v("Clear Filter")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass:
                          "extraFeature btn btn-primary waves-effect pull-right ml-2",
                        attrs: {
                          type: "submit",
                          id: "refreshList",
                          title: "Refresh"
                        },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.loadInventoryParts(false)
                          }
                        }
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-rotate-right",
                          attrs: { "aria-hidden": "true" }
                        })
                      ]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "admin-page-content",
            staticStyle: { "padding-top": "130px" }
          },
          [
            _c("label", { staticClass: "policy-text" }, [
              _vm._v(
                "** Total displayed below does not include Tax and Core Charges"
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "contact-grid-container" }, [
              _c("div", { staticClass: "row no-margin" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "app-filter-good-table-container text-align-placeholder-cutomer-dashboard"
                  },
                  [
                    _c("vue-good-table", {
                      ref: "listInventoryPartsTable",
                      attrs: {
                        mode: "remote",
                        title: "Order History",
                        totalRows: _vm.totalRecords,
                        columns: _vm.columns,
                        rows: _vm.rows,
                        "row-style-class": _vm.rowStyleClassFn,
                        "pagination-options": {
                          enabled: true,
                          mode: "pages",
                          pageLabel: "Page",
                          position: "both",
                          perPage: 25,
                          setCurrentPage: _vm.serverParams.setCurrentPage,
                          perPageDropdown: [25, 50, 100, 200, 500],
                          dropdownAllowAll: false
                        },
                        "search-options": {
                          enabled: false
                        }
                      },
                      on: {
                        "on-page-change": _vm.onPageChange,
                        "on-column-filter": _vm.onColumnFilter,
                        "on-per-page-change": _vm.onPerPageChange,
                        "on-sort-change": _vm.onSortChange,
                        "on-selected-rows-change": _vm.selectionChanged
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "pagination-top",
                            fn: function(props) {
                              return [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "vgt-wrap__footer top-pagination crm"
                                  },
                                  [
                                    _c("div", { staticClass: "row" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-sm-12 col-md-2 PerPage"
                                        },
                                        [
                                          _c("v-select", {
                                            attrs: {
                                              title: "Select Per Page",
                                              name: "customPerPage",
                                              id: "customPerPage",
                                              label: "text",
                                              clearable: false,
                                              searchable: false,
                                              filterable: false,
                                              options:
                                                _vm.serverParams
                                                  .perPageDropdown,
                                              placeholder: "Select Per Page"
                                            },
                                            on: {
                                              change: _vm.changedValueTask,
                                              input: function($event) {
                                                return _vm.changedValueTaskCustomPerPageTask()
                                              }
                                            },
                                            model: {
                                              value: _vm.serverParams.perPage,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.serverParams,
                                                  "perPage",
                                                  $$v
                                                )
                                              },
                                              expression: "serverParams.perPage"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "mt-2 col-sm-12 col-md-2 RowsDisplay"
                                        },
                                        [
                                          _c(
                                            "p",
                                            { staticClass: "pageRowCount" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.paginationDisplayRowsTask
                                                ) +
                                                  " of " +
                                                  _vm._s(_vm.totalRecords)
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-sm-12 col-md-6 Pagination"
                                        },
                                        [
                                          _c(
                                            "ul",
                                            { staticClass: "pagination" },
                                            [
                                              _c(
                                                "li",
                                                {
                                                  staticClass: "FirstPage",
                                                  attrs: { title: "First Page" }
                                                },
                                                [
                                                  Number(
                                                    _vm.serverParams.page
                                                  ) == 1
                                                    ? [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "page-link",
                                                            attrs: {
                                                              href:
                                                                "javascript:void(0)"
                                                            }
                                                          },
                                                          [_vm._v("1")]
                                                        )
                                                      ]
                                                    : [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "page-link",
                                                            attrs: {
                                                              href:
                                                                "javascript:void(0)"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.onPerticularPageClickTask(
                                                                  1
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [_vm._v("1")]
                                                        )
                                                      ]
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "li",
                                                {
                                                  staticClass:
                                                    "page-item PreviousPage",
                                                  attrs: {
                                                    title: "Previous Page"
                                                  }
                                                },
                                                [
                                                  Number(
                                                    _vm.serverParams.page
                                                  ) == 1
                                                    ? [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "page-link",
                                                            attrs: {
                                                              href:
                                                                "javascript:void(0)",
                                                              tabindex: "-1"
                                                            }
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fa fa-angle-left"
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                    : [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "page-link",
                                                            attrs: {
                                                              href:
                                                                "javascript:void(0)",
                                                              tabindex: "-1"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.onPerticularPageClickTask(
                                                                  Number(
                                                                    _vm
                                                                      .serverParams
                                                                      .page
                                                                  ) - 1
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fa fa-angle-left"
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _vm.pageNumberListTask() <
                                              _vm.displayPageTask
                                                ? [
                                                    _vm._l(
                                                      _vm.pageNumberListTask(),
                                                      function(n, index) {
                                                        return [
                                                          n ==
                                                          Number(
                                                            _vm.serverParams
                                                              .page
                                                          )
                                                            ? _c(
                                                                "li",
                                                                {
                                                                  staticClass:
                                                                    "PagesClass page-item active",
                                                                  attrs: {
                                                                    title:
                                                                      "Page " +
                                                                      n,
                                                                    id:
                                                                      "pageNumber" +
                                                                      n
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "a",
                                                                    {
                                                                      staticClass:
                                                                        "page-link",
                                                                      attrs: {
                                                                        href:
                                                                          "javascript:void(0)"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                                                                    " +
                                                                          _vm._s(
                                                                            n
                                                                          ) +
                                                                          "\n                                                                "
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            : _c(
                                                                "li",
                                                                {
                                                                  staticClass:
                                                                    "PagesClass page-item",
                                                                  attrs: {
                                                                    title:
                                                                      "Page " +
                                                                      n,
                                                                    id:
                                                                      "pageNumber" +
                                                                      n
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.onPerticularPageClickTask(
                                                                        n
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "a",
                                                                    {
                                                                      staticClass:
                                                                        "page-link",
                                                                      attrs: {
                                                                        href:
                                                                          "javascript:void(0)"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                                                                    " +
                                                                          _vm._s(
                                                                            n
                                                                          ) +
                                                                          "\n                                                                "
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                        ]
                                                      }
                                                    )
                                                  ]
                                                : [
                                                    Number(
                                                      _vm.serverParams.page
                                                    ) <= _vm.pageCompareTask
                                                      ? [
                                                          _vm._l(
                                                            _vm.displayPageTask,
                                                            function(n, index) {
                                                              return [
                                                                n ==
                                                                Number(
                                                                  _vm
                                                                    .serverParams
                                                                    .page
                                                                )
                                                                  ? _c(
                                                                      "li",
                                                                      {
                                                                        staticClass:
                                                                          "PagesClass page-item active",
                                                                        attrs: {
                                                                          title:
                                                                            "Page " +
                                                                            n,
                                                                          id:
                                                                            "pageNumber" +
                                                                            n
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "a",
                                                                          {
                                                                            staticClass:
                                                                              "page-link",
                                                                            attrs: {
                                                                              href:
                                                                                "javascript:void(0)"
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                                                                        " +
                                                                                _vm._s(
                                                                                  n
                                                                                ) +
                                                                                "\n                                                                    "
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _c(
                                                                      "li",
                                                                      {
                                                                        staticClass:
                                                                          "PagesClass page-item",
                                                                        attrs: {
                                                                          title:
                                                                            "Page " +
                                                                            n,
                                                                          id:
                                                                            "pageNumber" +
                                                                            n
                                                                        },
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            return _vm.onPerticularPageClickTask(
                                                                              n
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "a",
                                                                          {
                                                                            staticClass:
                                                                              "page-link",
                                                                            attrs: {
                                                                              href:
                                                                                "javascript:void(0)"
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                                                                        " +
                                                                                _vm._s(
                                                                                  n
                                                                                ) +
                                                                                "\n                                                                    "
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    )
                                                              ]
                                                            }
                                                          )
                                                        ]
                                                      : Number(
                                                          _vm.serverParams.page
                                                        ) >=
                                                        _vm.pageNumberListTask() -
                                                          (_vm.pageCompareTask -
                                                            1)
                                                      ? [
                                                          _vm._l(
                                                            _vm.pageNumberListTask(),
                                                            function(n, index) {
                                                              return [
                                                                n >
                                                                _vm.pageNumberListTask() -
                                                                  _vm.displayPageTask
                                                                  ? [
                                                                      n ==
                                                                      Number(
                                                                        _vm
                                                                          .serverParams
                                                                          .page
                                                                      )
                                                                        ? _c(
                                                                            "li",
                                                                            {
                                                                              staticClass:
                                                                                "PagesClass page-item active",
                                                                              attrs: {
                                                                                title:
                                                                                  "Page " +
                                                                                  n,
                                                                                id:
                                                                                  "pageNumber" +
                                                                                  n
                                                                              }
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "a",
                                                                                {
                                                                                  staticClass:
                                                                                    "page-link",
                                                                                  attrs: {
                                                                                    href:
                                                                                      "javascript:void(0)"
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "\n                                                                            " +
                                                                                      _vm._s(
                                                                                        n
                                                                                      ) +
                                                                                      "\n                                                                        "
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _c(
                                                                            "li",
                                                                            {
                                                                              staticClass:
                                                                                "PagesClass page-item",
                                                                              attrs: {
                                                                                title:
                                                                                  "Page " +
                                                                                  n,
                                                                                id:
                                                                                  "pageNumber" +
                                                                                  n
                                                                              },
                                                                              on: {
                                                                                click: function(
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.onPerticularPageClickTask(
                                                                                    n
                                                                                  )
                                                                                }
                                                                              }
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "a",
                                                                                {
                                                                                  staticClass:
                                                                                    "page-link",
                                                                                  attrs: {
                                                                                    href:
                                                                                      "javascript:void(0)"
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "\n                                                                            " +
                                                                                      _vm._s(
                                                                                        n
                                                                                      ) +
                                                                                      "\n                                                                        "
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ]
                                                                          )
                                                                    ]
                                                                  : _vm._e()
                                                              ]
                                                            }
                                                          )
                                                        ]
                                                      : [
                                                          _vm._l(
                                                            _vm.pageNumberListTask(),
                                                            function(n, index) {
                                                              return n >=
                                                                Number(
                                                                  _vm
                                                                    .serverParams
                                                                    .page
                                                                ) -
                                                                  (_vm.pageCompareTask -
                                                                    1) &&
                                                                n <=
                                                                  Number(
                                                                    _vm
                                                                      .serverParams
                                                                      .page
                                                                  ) +
                                                                    (_vm.pageCompareTask -
                                                                      1)
                                                                ? [
                                                                    n ==
                                                                    Number(
                                                                      _vm
                                                                        .serverParams
                                                                        .page
                                                                    )
                                                                      ? _c(
                                                                          "li",
                                                                          {
                                                                            staticClass:
                                                                              "PagesClass page-item active",
                                                                            attrs: {
                                                                              title:
                                                                                "Page " +
                                                                                n,
                                                                              id:
                                                                                "pageNumber" +
                                                                                n
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "a",
                                                                              {
                                                                                staticClass:
                                                                                  "page-link",
                                                                                attrs: {
                                                                                  href:
                                                                                    "javascript:void(0)"
                                                                                }
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "\n                                                                        " +
                                                                                    _vm._s(
                                                                                      n
                                                                                    ) +
                                                                                    "\n                                                                    "
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _c(
                                                                          "li",
                                                                          {
                                                                            staticClass:
                                                                              "PagesClass page-item",
                                                                            attrs: {
                                                                              title:
                                                                                "Page " +
                                                                                n,
                                                                              id:
                                                                                "pageNumber" +
                                                                                n
                                                                            },
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                return _vm.onPerticularPageClickTask(
                                                                                  n
                                                                                )
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "a",
                                                                              {
                                                                                staticClass:
                                                                                  "page-link",
                                                                                attrs: {
                                                                                  href:
                                                                                    "javascript:void(0)"
                                                                                }
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "\n                                                                        " +
                                                                                    _vm._s(
                                                                                      n
                                                                                    ) +
                                                                                    "\n                                                                    "
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        )
                                                                  ]
                                                                : _vm._e()
                                                            }
                                                          )
                                                        ]
                                                  ],
                                              _vm._v(" "),
                                              _c(
                                                "li",
                                                {
                                                  staticClass:
                                                    "page-item NextPage",
                                                  attrs: { title: "Next Page" }
                                                },
                                                [
                                                  Number(
                                                    _vm.serverParams.page
                                                  ) == _vm.pageNumberListTask()
                                                    ? [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "page-link",
                                                            attrs: {
                                                              href:
                                                                "javascript:void(0)"
                                                            }
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fa fa-angle-right"
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                    : [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "page-link",
                                                            attrs: {
                                                              href:
                                                                "javascript:void(0)"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.onPerticularPageClickTask(
                                                                  Number(
                                                                    _vm
                                                                      .serverParams
                                                                      .page
                                                                  ) + 1
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fa fa-angle-right"
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "li",
                                                {
                                                  staticClass: "LastPage",
                                                  attrs: { title: "Last Page" }
                                                },
                                                [
                                                  Number(
                                                    _vm.serverParams.page
                                                  ) == _vm.pageNumberListTask()
                                                    ? [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "page-link",
                                                            attrs: {
                                                              href:
                                                                "javascript:void(0)",
                                                              tabindex: "-1"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.pageNumberListTask()
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    : [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "page-link",
                                                            attrs: {
                                                              href:
                                                                "javascript:void(0)",
                                                              tabindex: "-1"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.onPerticularPageClickTask(
                                                                  _vm.pageNumberListTask()
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.pageNumberListTask()
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                ],
                                                2
                                              )
                                            ],
                                            2
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "mt-2 col-lg-1 col-md-1 col-sm-2 col-xs-6"
                                        },
                                        [
                                          _c(
                                            "p",
                                            { staticClass: "pageJumpLabel" },
                                            [_vm._v("Page : ")]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "mt-1 col-lg-1 col-md-1 col-sm-2 col-xs-6"
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.jumpToPageTask,
                                                expression: "jumpToPageTask"
                                              }
                                            ],
                                            staticClass:
                                              "form-control form-control-sm",
                                            attrs: {
                                              type: "text",
                                              name: "jumpToPageTask",
                                              id: "jumpToPageTask",
                                              placeholder: "Page"
                                            },
                                            domProps: {
                                              value: _vm.jumpToPageTask
                                            },
                                            on: {
                                              keyup: function($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                ) {
                                                  return null
                                                }
                                                return _vm.jumpToPageInTask.apply(
                                                  null,
                                                  arguments
                                                )
                                              },
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.jumpToPageTask =
                                                  $event.target.value
                                              }
                                            }
                                          })
                                        ]
                                      )
                                    ])
                                  ]
                                )
                              ]
                            }
                          },
                          {
                            key: "pagination-bottom",
                            fn: function(props) {
                              return [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "vgt-wrap__footer footer-pagination crm"
                                  },
                                  [
                                    _c("div", { staticClass: "row" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-sm-12 col-md-2 PerPage"
                                        },
                                        [
                                          _c("v-select", {
                                            attrs: {
                                              title: "Select Per Page",
                                              name: "customPerPage",
                                              id: "customPerPage",
                                              label: "text",
                                              clearable: false,
                                              searchable: false,
                                              filterable: false,
                                              options:
                                                _vm.serverParams
                                                  .perPageDropdown,
                                              placeholder: "Select Per Page"
                                            },
                                            on: {
                                              change: _vm.changedValueTask,
                                              input: function($event) {
                                                return _vm.changedValueTaskCustomPerPageTask()
                                              }
                                            },
                                            model: {
                                              value: _vm.serverParams.perPage,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.serverParams,
                                                  "perPage",
                                                  $$v
                                                )
                                              },
                                              expression: "serverParams.perPage"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "mt-2 col-sm-12 col-md-2 RowsDisplay"
                                        },
                                        [
                                          _c(
                                            "p",
                                            { staticClass: "pageRowCount" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.paginationDisplayRowsTask
                                                ) +
                                                  " of " +
                                                  _vm._s(_vm.totalRecords)
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-sm-12 col-md-6 Pagination"
                                        },
                                        [
                                          _c(
                                            "ul",
                                            { staticClass: "pagination" },
                                            [
                                              _c(
                                                "li",
                                                {
                                                  staticClass: "FirstPage",
                                                  attrs: { title: "First Page" }
                                                },
                                                [
                                                  Number(
                                                    _vm.serverParams.page
                                                  ) == 1
                                                    ? [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "page-link",
                                                            attrs: {
                                                              href:
                                                                "javascript:void(0)"
                                                            }
                                                          },
                                                          [_vm._v("1")]
                                                        )
                                                      ]
                                                    : [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "page-link",
                                                            attrs: {
                                                              href:
                                                                "javascript:void(0)"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.onPerticularPageClickTask(
                                                                  1
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [_vm._v("1")]
                                                        )
                                                      ]
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "li",
                                                {
                                                  staticClass:
                                                    "page-item PreviousPage",
                                                  attrs: {
                                                    title: "Previous Page"
                                                  }
                                                },
                                                [
                                                  Number(
                                                    _vm.serverParams.page
                                                  ) == 1
                                                    ? [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "page-link",
                                                            attrs: {
                                                              href:
                                                                "javascript:void(0)",
                                                              tabindex: "-1"
                                                            }
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fa fa-angle-left"
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                    : [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "page-link",
                                                            attrs: {
                                                              href:
                                                                "javascript:void(0)",
                                                              tabindex: "-1"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.onPerticularPageClickTask(
                                                                  Number(
                                                                    _vm
                                                                      .serverParams
                                                                      .page
                                                                  ) - 1
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fa fa-angle-left"
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _vm.pageNumberListTask() <
                                              _vm.displayPageTask
                                                ? [
                                                    _vm._l(
                                                      _vm.pageNumberListTask(),
                                                      function(n, index) {
                                                        return [
                                                          n ==
                                                          Number(
                                                            _vm.serverParams
                                                              .page
                                                          )
                                                            ? _c(
                                                                "li",
                                                                {
                                                                  staticClass:
                                                                    "PagesClass page-item active",
                                                                  attrs: {
                                                                    title:
                                                                      "Page " +
                                                                      n,
                                                                    id:
                                                                      "pageNumber" +
                                                                      n
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "a",
                                                                    {
                                                                      staticClass:
                                                                        "page-link",
                                                                      attrs: {
                                                                        href:
                                                                          "javascript:void(0)"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                                                                    " +
                                                                          _vm._s(
                                                                            n
                                                                          ) +
                                                                          "\n                                                                "
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            : _c(
                                                                "li",
                                                                {
                                                                  staticClass:
                                                                    "PagesClass page-item",
                                                                  attrs: {
                                                                    title:
                                                                      "Page " +
                                                                      n,
                                                                    id:
                                                                      "pageNumber" +
                                                                      n
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.onPerticularPageClickTask(
                                                                        n
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "a",
                                                                    {
                                                                      staticClass:
                                                                        "page-link",
                                                                      attrs: {
                                                                        href:
                                                                          "javascript:void(0)"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                                                                    " +
                                                                          _vm._s(
                                                                            n
                                                                          ) +
                                                                          "\n                                                                "
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                        ]
                                                      }
                                                    )
                                                  ]
                                                : [
                                                    Number(
                                                      _vm.serverParams.page
                                                    ) <= _vm.pageCompareTask
                                                      ? [
                                                          _vm._l(
                                                            _vm.displayPageTask,
                                                            function(n, index) {
                                                              return [
                                                                n ==
                                                                Number(
                                                                  _vm
                                                                    .serverParams
                                                                    .page
                                                                )
                                                                  ? _c(
                                                                      "li",
                                                                      {
                                                                        staticClass:
                                                                          "PagesClass page-item active",
                                                                        attrs: {
                                                                          title:
                                                                            "Page " +
                                                                            n,
                                                                          id:
                                                                            "pageNumber" +
                                                                            n
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "a",
                                                                          {
                                                                            staticClass:
                                                                              "page-link",
                                                                            attrs: {
                                                                              href:
                                                                                "javascript:void(0)"
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                                                                        " +
                                                                                _vm._s(
                                                                                  n
                                                                                ) +
                                                                                "\n                                                                    "
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _c(
                                                                      "li",
                                                                      {
                                                                        staticClass:
                                                                          "PagesClass page-item",
                                                                        attrs: {
                                                                          title:
                                                                            "Page " +
                                                                            n,
                                                                          id:
                                                                            "pageNumber" +
                                                                            n
                                                                        },
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            return _vm.onPerticularPageClickTask(
                                                                              n
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "a",
                                                                          {
                                                                            staticClass:
                                                                              "page-link",
                                                                            attrs: {
                                                                              href:
                                                                                "javascript:void(0)"
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                                                                        " +
                                                                                _vm._s(
                                                                                  n
                                                                                ) +
                                                                                "\n                                                                    "
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    )
                                                              ]
                                                            }
                                                          )
                                                        ]
                                                      : Number(
                                                          _vm.serverParams.page
                                                        ) >=
                                                        _vm.pageNumberListTask() -
                                                          (_vm.pageCompareTask -
                                                            1)
                                                      ? [
                                                          _vm._l(
                                                            _vm.pageNumberListTask(),
                                                            function(n, index) {
                                                              return [
                                                                n >
                                                                _vm.pageNumberListTask() -
                                                                  _vm.displayPageTask
                                                                  ? [
                                                                      n ==
                                                                      Number(
                                                                        _vm
                                                                          .serverParams
                                                                          .page
                                                                      )
                                                                        ? _c(
                                                                            "li",
                                                                            {
                                                                              staticClass:
                                                                                "PagesClass page-item active",
                                                                              attrs: {
                                                                                title:
                                                                                  "Page " +
                                                                                  n,
                                                                                id:
                                                                                  "pageNumber" +
                                                                                  n
                                                                              }
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "a",
                                                                                {
                                                                                  staticClass:
                                                                                    "page-link",
                                                                                  attrs: {
                                                                                    href:
                                                                                      "javascript:void(0)"
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "\n                                                                            " +
                                                                                      _vm._s(
                                                                                        n
                                                                                      ) +
                                                                                      "\n                                                                        "
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _c(
                                                                            "li",
                                                                            {
                                                                              staticClass:
                                                                                "PagesClass page-item",
                                                                              attrs: {
                                                                                title:
                                                                                  "Page " +
                                                                                  n,
                                                                                id:
                                                                                  "pageNumber" +
                                                                                  n
                                                                              },
                                                                              on: {
                                                                                click: function(
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.onPerticularPageClickTask(
                                                                                    n
                                                                                  )
                                                                                }
                                                                              }
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "a",
                                                                                {
                                                                                  staticClass:
                                                                                    "page-link",
                                                                                  attrs: {
                                                                                    href:
                                                                                      "javascript:void(0)"
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "\n                                                                            " +
                                                                                      _vm._s(
                                                                                        n
                                                                                      ) +
                                                                                      "\n                                                                        "
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ]
                                                                          )
                                                                    ]
                                                                  : _vm._e()
                                                              ]
                                                            }
                                                          )
                                                        ]
                                                      : [
                                                          _vm._l(
                                                            _vm.pageNumberListTask(),
                                                            function(n, index) {
                                                              return n >=
                                                                Number(
                                                                  _vm
                                                                    .serverParams
                                                                    .page
                                                                ) -
                                                                  (_vm.pageCompareTask -
                                                                    1) &&
                                                                n <=
                                                                  Number(
                                                                    _vm
                                                                      .serverParams
                                                                      .page
                                                                  ) +
                                                                    (_vm.pageCompareTask -
                                                                      1)
                                                                ? [
                                                                    n ==
                                                                    Number(
                                                                      _vm
                                                                        .serverParams
                                                                        .page
                                                                    )
                                                                      ? _c(
                                                                          "li",
                                                                          {
                                                                            staticClass:
                                                                              "PagesClass page-item active",
                                                                            attrs: {
                                                                              title:
                                                                                "Page " +
                                                                                n,
                                                                              id:
                                                                                "pageNumber" +
                                                                                n
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "a",
                                                                              {
                                                                                staticClass:
                                                                                  "page-link",
                                                                                attrs: {
                                                                                  href:
                                                                                    "javascript:void(0)"
                                                                                }
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "\n                                                                        " +
                                                                                    _vm._s(
                                                                                      n
                                                                                    ) +
                                                                                    "\n                                                                    "
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _c(
                                                                          "li",
                                                                          {
                                                                            staticClass:
                                                                              "PagesClass page-item",
                                                                            attrs: {
                                                                              title:
                                                                                "Page " +
                                                                                n,
                                                                              id:
                                                                                "pageNumber" +
                                                                                n
                                                                            },
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                return _vm.onPerticularPageClickTask(
                                                                                  n
                                                                                )
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "a",
                                                                              {
                                                                                staticClass:
                                                                                  "page-link",
                                                                                attrs: {
                                                                                  href:
                                                                                    "javascript:void(0)"
                                                                                }
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "\n                                                                        " +
                                                                                    _vm._s(
                                                                                      n
                                                                                    ) +
                                                                                    "\n                                                                    "
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        )
                                                                  ]
                                                                : _vm._e()
                                                            }
                                                          )
                                                        ]
                                                  ],
                                              _vm._v(" "),
                                              _c(
                                                "li",
                                                {
                                                  staticClass:
                                                    "page-item NextPage",
                                                  attrs: { title: "Next Page" }
                                                },
                                                [
                                                  Number(
                                                    _vm.serverParams.page
                                                  ) == _vm.pageNumberListTask()
                                                    ? [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "page-link",
                                                            attrs: {
                                                              href:
                                                                "javascript:void(0)"
                                                            }
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fa fa-angle-right"
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                    : [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "page-link",
                                                            attrs: {
                                                              href:
                                                                "javascript:void(0)"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.onPerticularPageClickTask(
                                                                  Number(
                                                                    _vm
                                                                      .serverParams
                                                                      .page
                                                                  ) + 1
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fa fa-angle-right"
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "li",
                                                {
                                                  staticClass: "LastPage",
                                                  attrs: { title: "Last Page" }
                                                },
                                                [
                                                  Number(
                                                    _vm.serverParams.page
                                                  ) == _vm.pageNumberListTask()
                                                    ? [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "page-link",
                                                            attrs: {
                                                              href:
                                                                "javascript:void(0)",
                                                              tabindex: "-1"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.pageNumberListTask()
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    : [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "page-link",
                                                            attrs: {
                                                              href:
                                                                "javascript:void(0)",
                                                              tabindex: "-1"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.onPerticularPageClickTask(
                                                                  _vm.pageNumberListTask()
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.pageNumberListTask()
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                ],
                                                2
                                              )
                                            ],
                                            2
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "mt-2 col-lg-1 col-md-1 col-sm-2 col-xs-6"
                                        },
                                        [
                                          _c(
                                            "p",
                                            { staticClass: "pageJumpLabel" },
                                            [_vm._v("Page : ")]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "mt-1 col-lg-1 col-md-1 col-sm-2 col-xs-6"
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.jumpToPageTask,
                                                expression: "jumpToPageTask"
                                              }
                                            ],
                                            staticClass:
                                              "form-control form-control-sm",
                                            attrs: {
                                              type: "text",
                                              name: "jumpToPageTask",
                                              id: "jumpToPageTask",
                                              placeholder: "Page"
                                            },
                                            domProps: {
                                              value: _vm.jumpToPageTask
                                            },
                                            on: {
                                              keyup: function($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                ) {
                                                  return null
                                                }
                                                return _vm.jumpToPageInTask.apply(
                                                  null,
                                                  arguments
                                                )
                                              },
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.jumpToPageTask =
                                                  $event.target.value
                                              }
                                            }
                                          })
                                        ]
                                      )
                                    ])
                                  ]
                                )
                              ]
                            }
                          },
                          _vm._l(_vm.rows, function(row, key) {
                            return {
                              key: "table-row",
                              fn: function(props) {
                                return [
                                  _c("div", { key: key }, [
                                    props.column.field == "action"
                                      ? _c(
                                          "div",
                                          [
                                            props.formattedRow["part_no"] !=
                                            "Total"
                                              ? [
                                                  props.row.isEditable &&
                                                  !_vm.isViewOnly
                                                    ? [
                                                        _c(
                                                          "router-link",
                                                          {
                                                            staticClass:
                                                              "btn edit-btn-vvg waves-effect",
                                                            attrs: {
                                                              title:
                                                                "Edit Part",
                                                              to: {
                                                                name:
                                                                  "CustomerUseParts",
                                                                query: {
                                                                  isEdit: "Yes"
                                                                },
                                                                params: {
                                                                  id:
                                                                    props.row
                                                                      .id,
                                                                  name:
                                                                    props.row
                                                                      .strip_part_no,
                                                                  isFrom:
                                                                    "dashboard",
                                                                  qty:
                                                                    props.row
                                                                      .inventory_qty,
                                                                  work_order:
                                                                    props.row
                                                                      .work_order,
                                                                  purchase_work_order:
                                                                    props.row
                                                                      .purchase_work_order,
                                                                  is_audited:
                                                                    props.row
                                                                      .isAudit
                                                                }
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fa fa-pencil",
                                                              attrs: {
                                                                "aria-hidden":
                                                                  "true"
                                                              }
                                                            })
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        props.row.isAudit != 1
                                                          ? _c(
                                                              "a",
                                                              {
                                                                staticClass:
                                                                  "btn edit-btn-vvg waves-effect",
                                                                attrs: {
                                                                  title:
                                                                    "Delete Order History"
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.deletePartsDepletionHistory(
                                                                      props.row
                                                                        .id
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c("i", {
                                                                  staticClass:
                                                                    "fa fa-trash-o",
                                                                  attrs: {
                                                                    "aria-hidden":
                                                                      "true"
                                                                  }
                                                                })
                                                              ]
                                                            )
                                                          : _vm._e()
                                                      ]
                                                    : void 0
                                                ]
                                              : _vm._e()
                                          ],
                                          2
                                        )
                                      : props.column.field == "invoice_no"
                                      ? _c("div", [
                                          _c("p", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.addNewLineInInovoiceColumn(
                                                  props.formattedRow[
                                                    "invoice_no"
                                                  ]
                                                )
                                              )
                                            }
                                          })
                                        ])
                                      : props.column.field == "invoice_date"
                                      ? _c("div", [
                                          _c("p", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.addNewLineInInovoiceColumn(
                                                  props.formattedRow[
                                                    "invoice_date"
                                                  ]
                                                )
                                              )
                                            }
                                          })
                                        ])
                                      : _c("div", [
                                          _vm._v(
                                            "\n                                            " +
                                              _vm._s(
                                                props.formattedRow[
                                                  props.column.field
                                                ]
                                              ) +
                                              "\n                                        "
                                          )
                                        ])
                                  ])
                                ]
                              }
                            }
                          }),
                          {
                            key: "selected-row-actions",
                            fn: function(computed) {
                              return _c("div", {}, [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(computed.selectedRows) +
                                    "\n                                    "
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-success",
                                    attrs: { title: "Delete" },
                                    on: {
                                      click: function($event) {
                                        return _vm.deleteInventoryParts()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "Delete Inventory Part(s) (" +
                                        _vm._s(_vm.selectedRows) +
                                        ")"
                                    )
                                  ]
                                )
                              ])
                            }
                          }
                        ],
                        null,
                        true
                      )
                    })
                  ],
                  1
                )
              ])
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("customer-footer")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2507d795", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2507d795","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Customer/CustomerOrderHistory.vue
// module id = null
// module chunks = 